import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useMixins } from '@/modules/promotion/plan/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionPlanEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { fetchLinkableItems, linkableItemOption, selectedItemType } = useMixins();

    const beforeFetch = async () => {
        await fetchLinkableItems();
    };

    const model = reactive({
        id: route.params?.id,
        name: null,
        status: null,
        timeUnit: 0,
        timeDuration: 0,
        publishTime: null,
        unpublishTime: null,
        itemId: null,
        image: null,
        imageStatus: null,
        imageFile: null,

        get type() {
            return selectedItemType.value;
        },
        set type(value) {
            selectedItemType.value = value;
        }
    });

    const validations = {
        name: { required },
        unpublishTime: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => promotionService.plan.get(model.id),
        onSuccess: ({ data }) => {
            data.publishTime = new Date(data.publishTime);
            data.unpublishTime = data.unpublishTime ? new Date(data.unpublishTime) : null;
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_PROMOTION.PLAN.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => {
                const unpublishTime = model.unpublishTime?.getTime() ?? null;
                return promotionService.plan.update(model.id, model.name, unpublishTime, model.imageFile);
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_PROMOTION.PLAN.INDEX })
        })
    };

    return { model, v$, beforeFetch, fetch, actions, timeUnits, linkableItemOption, selectedItemType };
}
